module.exports = __webpack_public_path__ + "img/inncash-login-home-webinar.0d55c7ee.webp";